import React, { useRef, useState } from "react";

import textcomponent from "../../../../assets/images/canvasIcons/textcomponent.svg";
import writingcomponent from "../../../../assets/images/canvasIcons/writingcomponent.svg";
import drawcomponent from "../../../../assets/images/canvasIcons/drawcomponent.svg";
import filecomponent from "../../../../assets/images/canvasIcons/filecomponent.svg";
import embedcomponent from "../../../../assets/images/canvasIcons/embedcomponent.svg";

import rectshape from "../../../../assets/images/canvasIcons/rectshape.svg";
import circleShape from "../../../../assets/images/canvasIcons/circleshape.svg";
import triangleShape from "../../../../assets/images/canvasIcons/triangleshape.svg";
import starShape from "../../../../assets/images/canvasIcons/starshape.svg";
import useToggle from "../../../../components/useToggle";

const listItem = [
  {
    id: 112,
    name: "Writing block",
    icon: writingcomponent,
    type: "editor"
  },
  {
    id: 111,
    name: "Text",
    icon: textcomponent,
    type: "text"
  },
  {
    id: 211,
    name: "Draw shape",
    icon: drawcomponent,
    type: 'shape',
    children: [
      {
        name: "rectangle",
        image: rectshape,
      },
      {
        name: "circle",
        image: circleShape,
      },
      {
        name: "triangle",
        image: triangleShape,
      },
      {
        name: "star",
        image: starShape,
      },
    ],
  },
  {
    id: 121,
    name: "Add image",
    icon: filecomponent,
    type: "image"
  },
  {
    id: 212,
    name: "Upload",
    icon: embedcomponent,
    type: 'embed'
  },
];

const BlocksHeader = ({ onHandleBlockRender }) => {
  const [isVisible, setVisible] = useState(false);
  const toggleShowDropdown = () => {
    setVisible(!isVisible);
  };

  const shapesRef = useRef(null);

  useToggle(shapesRef, isVisible, toggleShowDropdown)

  const addShapesToCanvas = (shape) => {
    console.log(shape);
    const shapeData = {name: shape, type: 'shape'}
    onHandleBlockRender(shapeData);
  };

  const selectedBlock = (item) => {
    if (item.name === "Draw shape") {
      toggleShowDropdown();
    } else {
      onHandleBlockRender(item);
    }
  };

  return (
    <div className="blockHeader d--flex justify-center align-center">
      <div className="blockHeader__list">
        {listItem.map((item) => {
          const linkProps = {};
          const hasChildren = item.children !== undefined;
          if (hasChildren) {
            linkProps["onClick"] = toggleShowDropdown;
          }
          return (
            <div
              className="blockHeader__listItem"
              {...linkProps}
              onClick={() => selectedBlock(item)}
            >
              <img src={item.icon} alt={item.name} />
              <span>{item.name}</span>
              <div className="blockHeader__listItemTooltip">{item.name}</div>
              {hasChildren && (
                <div
                  className={
                    isVisible
                      ? "blockHeader__shapes display_dropdown"
                      : "blockHeader__shapes"
                  }
                  onClick={toggleShowDropdown}
                  ref={shapesRef}
                >
                  {item.children.map((child) => (
                    <div
                      className="listitem"
                      onClick={() => addShapesToCanvas(child.name)}
                    >
                      <img src={child.image} alt={child.name} />
                      <span className="shape--title">{child.name}</span>
                    </div>
                  ))}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default BlocksHeader;
